// Рамка для dropzone

const template = `
<svg viewBox="0 0 940 295" fill="none" xmlns="http://www.w3.org/2000/svg" class="dropzone__border">
    <rect
        stroke-dashoffset="10"
        x="2"
        y="2"
        width="936"
        height="291"
        rx="4"
        :fill="fill"
        stroke-width="2"
        stroke-linecap="square"
        stroke-linejoin="round"
        stroke-dasharray="12 12"
    />
</svg>`;

const props = { fill: "none" };

export default {
    props,
    template,
};
